import { Injectable } from '@angular/core';
import { consoleHelper } from 'lib/helpers/console-helper.class.js';
import { RequestService } from 'lib/request/request.service.js';
import { environment } from 'src/app/environments/environment.js';
import { jsCookieHelper } from '../helpers/js-cookie-helper.class.js';
import { PlatformService } from '../platform/index.js';
import { CookieName } from './cookie-names.js';

@Injectable({
	providedIn: 'root'
})
export class CookieService {
	constructor(private readonly platformService: PlatformService, private readonly requestService: RequestService) {}

	getCookie(name: CookieName): string | undefined {
		const fullCookieName = this.getFullCookieName(name);

		// get cookie on browser
		if (this.platformService.isBrowser) {
			return jsCookieHelper.getCookie(fullCookieName);
		}

		// get cookie on server
		return this.requestService.getCookieFromRequest(fullCookieName);
	}

	setCookie(
		name: CookieName,
		value: string,
		options?: {
			readonly expiresInDays?: number;
		}
	): void {
		const fullCookieName = this.getFullCookieName(name);

		if (this.platformService.isBrowser) {
			jsCookieHelper.setCookie(fullCookieName, value, options);
			return;
		}

		// set cookie on server
		this.requestService.setCookieInRequest(fullCookieName, value, options);
	}

	deleteCookie(name: CookieName): void {
		const fullCookieName = this.getFullCookieName(name);

		if (this.platformService.isBrowser) {
			jsCookieHelper.deleteCookie(fullCookieName);
			return;
		}

		// delete cookie on server
		consoleHelper.logToConsole({
			type: 'Warning',
			message: `Cannot delete cookie '${fullCookieName}' on server`
		});
	}

	private getFullCookieName(name: CookieName): string {
		return `${environment.appName}_${name}`;
	}
}
